var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const propsToClassNamesMap = {
    size: {
        sm: 'c-button--sm',
        md: 'c-button--md',
        lg: 'c-button--lg',
    },
    variant: {
        filled: 'c-button__filled',
        basic: 'c-button__basic',
        outlined: 'c-button__outlined',
    },
    color: {
        primary: '--primary',
        secondary: '--secondary',
        default: '--default',
    },
    disabled: 'is-disabled',
};
const Button = (_a) => {
    var { className, children, color = 'default', size = 'md', variant = 'filled' } = _a, props = __rest(_a, ["className", "children", "color", "size", "variant"]);
    const addClassNames = (baseClass, ...overrides) => [
        baseClass,
        propsToClassNamesMap.size[size],
        propsToClassNamesMap.variant[variant],
        propsToClassNamesMap.variant[variant] + propsToClassNamesMap.color[color],
        ...(className ? [className] : []),
        ...overrides,
    ].join(' ');
    if ((props === null || props === void 0 ? void 0 : props.as) === 'a' || (props === null || props === void 0 ? void 0 : props.href)) {
        return (_jsx("a", Object.assign({ className: addClassNames('c-button') }, props, { children: _jsx("span", Object.assign({ className: 'c-button__label' }, { children: _jsx("span", Object.assign({ className: 'c-button__label-text' }, { children: children })) })) })));
    }
    return (_jsx("button", Object.assign({ className: addClassNames('c-button'), onClick: (e) => {
            const { onClick } = props;
            e.preventDefault();
            return onClick ? onClick(e) : null;
        } }, props, { children: _jsx("span", Object.assign({ className: 'c-button__label' }, { children: _jsx("span", Object.assign({ className: 'c-button__label-text' }, { children: children })) })) })));
};
export { Button };
